import { render, staticRenderFns } from "./RastreabilidadeAmostra.vue?vue&type=template&id=b24a1d1a&"
import script from "./RastreabilidadeAmostra.vue?vue&type=script&lang=js&"
export * from "./RastreabilidadeAmostra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports